const removeAllItemsByValue = (arr, value) => {
    let i = 0;
    while (i < arr.length) {
        if (arr[i] === value) {
            arr.splice(i, 1);
        } else {
            ++i;
        }
    }
    return arr;
};
const ensureNeighboursInArray = (item, count, array) => {
    const buffer = 2;
    const mask = [0];
    for (let i = 0; i <= buffer; i++) {
        if (i < count) {
            mask.push(i);
            mask.push(i * -1);
        }
    }

    for (let index = 0; index < mask.length; index++) {
        const offset = mask[index];
        let idx = item + offset;
        if (idx > count) {
            idx = idx - count;
        }
        if (idx < 0) {
            idx = idx + count;
        }
        if (!array.includes(idx)) {
            array.push(idx);
        }
    }
    return array;
};
const range = (min, max) => {
    const len = max - min + 1;
    const arr = new Array(len);
    for (let i = 0; i < len; i++) {
        arr[i] = min + i;
    }
    return arr;
};
const randomItem = (items) => {
    return items[Math.floor(Math.random() * items.length)];
};
export { removeAllItemsByValue, ensureNeighboursInArray, range, randomItem };
